import { ObjectHelper } from "../Helpers/ObjectHelper";
import { Property } from "../RadObject";
import { IPropertyComparer, PropertyComparer, PropertyComparerPropertyValues } from "./PropertyComparer";
import { NAMESPACE } from "./_Namespace";

export type PropertyComparerGreaterThanPropertyValues =
    PropertyComparerPropertyValues
    & {
    };

export type PropertyComparerGreaterThanProperties = {
    [name in keyof PropertyComparerGreaterThanPropertyValues]: Property<PropertyComparerGreaterThanPropertyValues[name]>
};

export interface IPropertyComparerGreaterThan extends IPropertyComparer, PropertyComparerGreaterThanProperties
{
}

export class PropertyComparerGreaterThan extends PropertyComparer<PropertyComparerGreaterThanPropertyValues> implements IPropertyComparerGreaterThan
{
    public static override classNamespace = NAMESPACE + "PropertyComparerGreaterThan";
    public static override className = "PropertyComparerGreaterThan";

    // #region Overrides

    public override compare(propertyValue: any, constantValue: any): boolean
    {
        return ObjectHelper.compare(propertyValue, constantValue) > 0;
    }

    // #endregion
}
